<div *ngIf="colectiva?.esDestacada; else noRecomendada" class="propuesta-recomendada">
  <h4>
    <ca-icon>star</ca-icon>
    {{ 'SALUD.RECOMENDADOR.PRODUCTO_DESTACADO' | translate }}
  </h4>
</div>

<ng-template #noRecomendada>
  <div class="propuesta-no-recomendada"></div>
</ng-template>

<div class="propuesta-tarificada">
    <div class="propuesta-tarificada-header">
        <h5 *ngIf="propuesta?.modalidadColectiva">{{propuesta.modalidadColectiva?.toUpperCase()}}</h5>
        <p *ngIf="propuesta?.descripcionModalidadColectiva" [innerHTML]="getDescripcionModalidad()"></p>
    </div>

    <div class="propuesta-tarificada-copagos" *ngIf="propuestaActiva?.copagos?.length > 0">
        <table class="tabla-copagos">
            <tr *ngFor="let p of propuestaActiva?.copagos">
                <td class="desc">{{ p.descripcion }}</td>
                <td class="importe">{{ p.importe | currency:'EUR' }}</td>
            </tr>
        </table>
    </div>

    <div class="propuesta-tarificada-copagos mt-3" *ngIf="propuestaActiva?.copagos?.length > 0">
        <span class="desc">{{ 'SALUD.RECOMENDADOR.LABEL_OPCION.MENSAJE_ESTATICO_COPAGOS' | translate }}</span>
    </div>

    <div class="propuesta-tarificada-botonera" *ngIf="propuestaActiva?.recibo">
        
        <div class="precio">
            {{ getImporteMostrar() | currency:'EUR'}}
            <button ca-button-icon type="button" (click)="abrirModalTarificacion()">
                <ca-icon>add_circle</ca-icon>
            </button>
        </div>
        <div class="col-12 row fila-boton">
            <button ca-button class="ca-btn-icon__container mb-2" (click)="contratarPoliza()">
                {{'MENU.PRIVADO.CONTRATAR' | translate}}
            </button>
        </div>
        <div class="col-12 row fila-boton">
            <button ca-button class="ca-btn-icon__container" (click)="imprimirPoliza()">
                {{'MENU.PRIVADO.IMPRIMIR' | translate}}
            </button>
        </div>
        <div class="row col-12 m-auto" *ngIf="propuestaDescuento && colectivaDescuento">
            <ca-checkbox (valueChange)="changeDescuento($event)" class="m-auto">
                {{ 'SALUD.RECOMENDADOR.CHECK_DESCUENTO' | translate}}
            </ca-checkbox>
        </div>
    </div>

    <div class="propuesta-tarificada-footer col-12 row mt-4 mb-5">
        <a (click)="abrirModalInformacion()" href="javascript:void(0);">
            <span id="_label" class="PRS_label">{{ 'SALUD.RECOMENDADOR.LABEL_OPCION.CONSULTAR_INFORMACION' | translate }}</span>
        </a>
        <a (click)="abrirModalIntelij()" class="mt-3" href="javascript:void(0);" *ngIf="mostrarComparativoCoberturas">
            <span id="_label" class="PRS_label">{{ 'SALUD.RECOMENDADOR.LABEL_OPCION.CONSULTAR_COBERTURAS' | translate }}</span>
        </a>
    </div>
</div>